import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _mutations, _scopes, _mutationId;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
// src/mutationCache.ts
import { notifyManager } from "./notifyManager.js";
import { Mutation } from "./mutation.js";
import { matchMutation, noop } from "./utils.js";
import { Subscribable } from "./subscribable.js";
var MutationCache = (_mutations = /*#__PURE__*/new WeakMap(), _scopes = /*#__PURE__*/new WeakMap(), _mutationId = /*#__PURE__*/new WeakMap(), class MutationCache extends Subscribable {
  constructor() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    _classPrivateFieldInitSpec(this, _mutations, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _scopes, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _mutationId, {
      writable: true,
      value: void 0
    });
    this.config = config;
    _classPrivateFieldSet(this, _mutations, /* @__PURE__ */new Set());
    _classPrivateFieldSet(this, _scopes, /* @__PURE__ */new Map());
    _classPrivateFieldSet(this, _mutationId, 0);
  }
  build(client, options, state) {
    var _this$mutationId;
    const mutation = new Mutation({
      mutationCache: this,
      mutationId: _classPrivateFieldSet(this, _mutationId, (_this$mutationId = _classPrivateFieldGet(this, _mutationId), ++_this$mutationId)),
      options: client.defaultMutationOptions(options),
      state
    });
    this.add(mutation);
    return mutation;
  }
  add(mutation) {
    _classPrivateFieldGet(this, _mutations).add(mutation);
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const scopedMutations = _classPrivateFieldGet(this, _scopes).get(scope);
      if (scopedMutations) {
        scopedMutations.push(mutation);
      } else {
        _classPrivateFieldGet(this, _scopes).set(scope, [mutation]);
      }
    }
    this.notify({
      type: "added",
      mutation
    });
  }
  remove(mutation) {
    if (_classPrivateFieldGet(this, _mutations).delete(mutation)) {
      const scope = scopeFor(mutation);
      if (typeof scope === "string") {
        const scopedMutations = _classPrivateFieldGet(this, _scopes).get(scope);
        if (scopedMutations) {
          if (scopedMutations.length > 1) {
            const index = scopedMutations.indexOf(mutation);
            if (index !== -1) {
              scopedMutations.splice(index, 1);
            }
          } else if (scopedMutations[0] === mutation) {
            _classPrivateFieldGet(this, _scopes).delete(scope);
          }
        }
      }
    }
    this.notify({
      type: "removed",
      mutation
    });
  }
  canRun(mutation) {
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const mutationsWithSameScope = _classPrivateFieldGet(this, _scopes).get(scope);
      const firstPendingMutation = mutationsWithSameScope === null || mutationsWithSameScope === void 0 ? void 0 : mutationsWithSameScope.find(m => m.state.status === "pending");
      return !firstPendingMutation || firstPendingMutation === mutation;
    } else {
      return true;
    }
  }
  runNext(mutation) {
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      var _classPrivateFieldGet2, _foundMutation$contin;
      const foundMutation = (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _scopes).get(scope)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.find(m => m !== mutation && m.state.isPaused);
      return (_foundMutation$contin = foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) !== null && _foundMutation$contin !== void 0 ? _foundMutation$contin : Promise.resolve();
    } else {
      return Promise.resolve();
    }
  }
  clear() {
    notifyManager.batch(() => {
      _classPrivateFieldGet(this, _mutations).forEach(mutation => {
        this.notify({
          type: "removed",
          mutation
        });
      });
      _classPrivateFieldGet(this, _mutations).clear();
      _classPrivateFieldGet(this, _scopes).clear();
    });
  }
  getAll() {
    return Array.from(_classPrivateFieldGet(this, _mutations));
  }
  find(filters) {
    const defaultedFilters = _objectSpread({
      exact: true
    }, filters);
    return this.getAll().find(mutation => matchMutation(defaultedFilters, mutation));
  }
  findAll() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this.getAll().filter(mutation => matchMutation(filters, mutation));
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }
  resumePausedMutations() {
    const pausedMutations = this.getAll().filter(x => x.state.isPaused);
    return notifyManager.batch(() => Promise.all(pausedMutations.map(mutation => mutation.continue().catch(noop))));
  }
});
function scopeFor(mutation) {
  var _mutation$options$sco;
  return (_mutation$options$sco = mutation.options.scope) === null || _mutation$options$sco === void 0 ? void 0 : _mutation$options$sco.id;
}
export { MutationCache };